// One pure engine shared by free server previews and the paid browser worker.
export {prepareHair, recolorHair, colorRamp} from "@/gcp-functions/helpers/hairStudioRecolor";
export type {PreparedHair} from "@/gcp-functions/helpers/hairStudioRecolor";
